/**
 * Centralized timeout and delay constants
 * Use these instead of hardcoded timeout values throughout the codebase
 */

// ============================================================================
// UI Notification Timeouts
// ============================================================================

/** Standard timeout for copy-to-clipboard feedback (2 seconds) */
export const COPY_FEEDBACK_TIMEOUT_MS = 2000;

/** Short notification timeout (1.5 seconds) */
export const NOTIFICATION_SHORT_TIMEOUT_MS = 1500;

/** Long notification timeout (4 seconds) */
export const NOTIFICATION_LONG_TIMEOUT_MS = 4000;

// ============================================================================
// Retry & Initialization Delays
// ============================================================================

/** Short retry delay (1 second) */
export const RETRY_DELAY_SHORT_MS = 1000;

/** Medium retry delay (3 seconds) */
export const RETRY_DELAY_MEDIUM_MS = 3000;

/** Long retry delay (5 seconds) */
export const RETRY_DELAY_LONG_MS = 5000;

/** Extended retry delay (10 seconds) */
export const RETRY_DELAY_EXTENDED_MS = 10000;

// ============================================================================
// Polling Intervals
// ============================================================================

/** Short polling interval (1 second) */
export const POLL_INTERVAL_SHORT_MS = 1000;

/** Medium polling interval (5 seconds) */
export const POLL_INTERVAL_MEDIUM_MS = 5000;

/** Long polling interval (30 seconds) */
export const POLL_INTERVAL_LONG_MS = 30000;

/** Very long polling interval (1 minute) */
export const POLL_INTERVAL_VERY_LONG_MS = 60000;

// ============================================================================
// Session & Connection Timeouts
// ============================================================================

/** Session heartbeat interval (5 minutes) */
export const SESSION_HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

/** QR code timeout (4 minutes) */
export const QR_CODE_TIMEOUT_MS = 4 * 60 * 1000;

/** WhatsApp disconnect check interval (15 minutes) */
export const WA_DISCONNECT_CHECK_MS = 15 * 60 * 1000;

/** Message expiration timeout (30 minutes) */
export const MESSAGE_EXPIRATION_MS = 30 * 60 * 1000;

/** Retry interval after send (5 minutes) */
export const RETRY_AFTER_SEND_INTERVAL_MS = 5 * 60 * 1000;

// ============================================================================
// Test Timeouts
// ============================================================================

/** Default test timeout */
export const TEST_DEFAULT_TIMEOUT_MS = 50000;

/** Extended test timeout */
export const TEST_EXTENDED_TIMEOUT_MS = 10000;

// ============================================================================
// Debounce & Throttle
// ============================================================================

/** Standard debounce delay for user input */
export const DEBOUNCE_INPUT_MS = 300;

/** Standard debounce delay for search */
export const DEBOUNCE_SEARCH_MS = 500;

/** Debounce cooldown for rapid operations */
export const DEBOUNCE_COOLDOWN_MS = 2000;
